<template>
  <div class="container-fluid">
    <div class="row dataTable-filters orderlines-dt-filter">
      <!-- DATE -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.deviations.dateFilter') }}</label>
        <datepicker
            :disabled="defaultRecordIdFilter ? true : false"
            monday-first
            :language="nl"
            :format="dateDisplay"
            @selected="selectedDateChanged"
            :value="selectedDate"
            id="selectedDate" input-class="form-control "/>
      </div>

      <!-- TYPE DEVIATION -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.deviations.typeFilter.title') }}</label>
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{ $t('shopfloor.teamlead.deviations.typeFilter.filtered') }}: {{
                customFilters[0].options.values.length
              }}</span>
          </button>
          <div class="dropdown-menu">
            <input v-model="searchType" class="form-control mb-3" type="text"
                   :placeholder="$t('shopfloor.teamlead.deviations.typeFilter.title')">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox" v-for="(type, index) in searchByType"
                   :key="type+'-'+index">
                <input v-model="customFilters[0].options.values"
                       :value="type"
                       type="checkbox"
                       :id="'type-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'type-'+index">
                  <span>{{ $t('shopfloor.teamlead.deviations.deviations.' + type) }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TYPE DEVIATION -->
      <div class="table-filter" v-if="defaultRecordIdFilter && getDeviations.length">
        <label>{{ $t('shopfloor.teamlead.deviations.packingListNumber') }}</label>
        <div class="packing-list-number-grid">
          <div class="pln-title">
            {{ lodash.first(getDeviations).packingListNumber }}
          </div>
          <div class="close-bttn" @click="undoPackingListNrSelection()">
            <i class="fas fa-times-circle"></i>
          </div>
        </div>
      </div>


    </div>

    <div class="table-responsive">
      <datatables
          :columns="getColumns()"
          ref="deviationsTable"
          :rows="getDeviations"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :key="selectedDate.toJSON()"
          :customFilters="customFilters"
          tableID="deviations-dt"
          v-if="getDeviations"
          :deleteFunction="deleteDeviation"
      />
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import dataTables from '../../mixins/datatables';
import Datepicker from 'vuejs-datepicker';
import {nl} from 'vuejs-datepicker/dist/locale';


export default {
  name: 'teamlead-deviations',
  components: {Datepicker},
  mixins: [dataTables],
  data() {
    return {
      lodash: _,
      deletingDeviations: [],
      saving: undefined,
      defaultRecordIdFilter: undefined,
      nl: nl,
      searchType: '',
      typesToIncrement: ['shortage'],
      selectedDate: new Date(),
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d<\/i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        drawCallback: this.afterDraw,
        select: true,
        pageLength: 10,
        order: [[10, 'desc']]
      },
      customFilters: []
    };
  },
  computed: {
    ...mapGetters('deviations', ['getDeviations']),
    ...mapGetters('users', ['getMeBasic']),
    searchByType() {
      return _.uniq(_.map(this.getDeviations.filter((deviation) => {
        return deviation.type && `${deviation.type}`.toLowerCase().indexOf(`${this.searchType}`.toLowerCase()) >= 0;
      }), 'type')).sort(this.sortCaseInsensitive);
    },
    uniqueStates() {
      return ['idle', 'busy', 'done'];
    }
  },
  methods: {
    ...mapActions('incomingOrderProducts', [
      'updateAmountLocally'
    ]),
    async deleteDeviation(deviation) {
      if (this.deletingDeviations.indexOf(deviation.id) > -1) {
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'info',
          title: this.$t('shopfloor.deviations.alreadyDeleted')
        });
      } else {
        let confirmationPopUp = await this.$swal({
          title: this.$t('shopfloor.deviations.dialogConfirm.title'),
          text: this.$t('shopfloor.deviations.dialogConfirm.message'),
          confirmButtonText: this.$t('shopfloor.deviations.dialogConfirm.confirm'),
          cancelButtonText: this.$t('shopfloor.deviations.dialogConfirm.dismiss'),
          showCancelButton: true
        });
        if (confirmationPopUp.value) {
          if (this.typesToIncrement.indexOf(deviation.type) > -1) {
            const locationDoc = await this.showPickLocationSwal();
            if (locationDoc) {
              this.deletingDeviations.push(deviation.id);
              this.$FB.collection('undo-deviations').add({
                ...deviation,
                locationToMoveTo: locationDoc,
                undoneBy: this.getMeBasic,
                undoneAt: new Date()
              });
              this.showUndoneToast();
            }
          } else {
            this.deletingDeviations.push(deviation.id);
            this.$FB.collection('undo-deviations').add(deviation);
            this.showUndoneToast();
          }
        }
      }
    },
    showUndoneToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.deviations.undoneSuccess')
      });
    },
    async showPickLocationSwal() {
      const inputValue = '';
      let locationDocData = null;
      await this.$swal({
        title: this.$t('shopfloor.deviations.pickLocationDialog.title'),
        input: 'text',
        inputLabel: this.$t('shopfloor.deviations.pickLocationDialog.message'),
        inputValue: inputValue,
        confirmButtonText: this.$t('shopfloor.deviations.pickLocationDialog.confirm'),
        cancelButtonText: this.$t('shopfloor.deviations.pickLocationDialog.dismiss'),
        showCancelButton: true,
        inputValidator: async (value) => {
          if (!value) {
            return this.$t('shopfloor.deviations.pickLocationDialog.errorNoLocation')
          } else {
            const result = await this.$FB.collection('locations').where('name', '==', value).where('companyId', '==', this.getMeBasic.companyId).get();
            if (result.docs.length) {
              locationDocData = _.first(result.docs).data();
              return null;
            } else {
              return this.$t('shopfloor.deviations.pickLocationDialog.errorNoValidLocation')
            }
          }
        }
      });
      return locationDocData;
    },
    create_UUID() {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    undoPackingListNrSelection() {
      this.defaultRecordIdFilter = undefined;
      this.resetFilters();
      this.selectedDateChanged(new Date());
    },
    selectedDateChanged(date) {
      // if (this.defaultRecordIdFilter) {
      //   this.defaultRecordIdFilter = undefined;
      // }
      this.selectedDate = date;
      this.resetFilters();
      return this.openDeviationsChannel(moment(this.selectedDate));
    },
    dateDisplay(date) {
      return moment(date).format('DD/MM/YY');
    },
    sortCaseInsensitive(a, b) {
      return `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase());
    },
    async openDeviationsChannel(date) {
      let skipCloseDB = false;
      if (!date) {
        date = moment();
        skipCloseDB = true;
      }
      if (!skipCloseDB) {
        await this.$store.dispatch('deviations/closeDBChannel', {clearModule: true});
      }

      let where = [
        ['companyId', '==', this.getMeBasic.companyId]
      ]

      if (this.defaultRecordIdFilter) {
        where.push(['recordId', '==', this.defaultRecordIdFilter]);
      } else {
        where.push(['created_at', '>=', moment(this.selectedDate).startOf('day').toDate()]);
        where.push(['created_at', '<=', moment(this.selectedDate).endOf('day').toDate()]);
      }
      // if (this.currentView === 'loading') {
      //   where.push(['location', '==', 'loading'])
      // } else {
      //   where.push(['location', '==', 'unloading'])
      // }
      await this.$store.dispatch('deviations/openDBChannel', {where})

      this.$store.commit('setLoading', false)
    },
    getColumns() {
      let self = this;
      let showDate = this.defaultRecordIdFilter ? true : false;
      return [
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.truck'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.truck ? data.truck : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.trailer'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.trailer ? data.trailer : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.productNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.locationAdditional ? data.locationAdditional : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.type'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.type ? self.$t('shopfloor.teamlead.deviations.deviations.' + data.type) : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.remark'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.remark ? `<div style="width: 125px; white-space: normal;">${data.remark}</div>` : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.customer'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.customer ? `<div style="width: 125px; white-space: normal;">${data.customer}</div>` : '';

          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.address'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            if (!data.receiver) {
              return '';
            } else {
              return `${data.receiver.zipcode}, ${data.receiver.city}<br/>${data.receiver.address}<br/>${data.receiver.country}`;
            }
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.packingListNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.packingListNumber ? data.packingListNumber : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.productName'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.productName ? data.productName : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.amount'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.amount ? data.amount : 0;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.createdAt'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.created_at ? moment(data.created_at.toDate()).format(showDate ? 'DD-MM-YYYY HH:mm:ss' : 'HH:mm:ss') : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.userName'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return data.userName ? data.userName : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.deviations.url'),
          searchable: true,
          className: 'alignCenter urlColumn',
          sortable: false,
          visible: true,
          render(data) {
            return data.image ? `<div class="imageLink" onclick="window.open('${data.image}', '_blank')">${self.$t('shopfloor.teamlead.deviations.openUrl')}</div>` : '';
          }
        },
        {
          data: null,
          name: '',
          searchable: true,
          className: 'alignCenter urlColumn',
          sortable: false,
          visible: true,
          render(data) {
            return '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
          }
        },
      ];
    },
    async closeView(to) {
      return this.$store.dispatch('resetStoreModules', ['deviations']).catch(console.error);
    },
    resetFilters() {
      this.customFilters = [
        {
          filter: 'arrayContains',
          keyToFilter: 'type',
          options: {
            values: []
          }
        }
      ];
      this.searchType = '';
    },
    async createView() {
      this.selectedDate = new Date();
      this.resetFilters();

      return this.openDeviationsChannel();
    }
  },
  watch: {
    filterOpen: function (filter) {
      if (filter) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    await this.closeView(to);
    next();
  },
  created() {
    if (this.$route.params && this.$route.params.recordId) {
      this.defaultRecordIdFilter = this.$route.params.recordId;
    }
    this.createView();
  }
};
</script>


<style lang="scss">

.packing-list-number-grid {
  display: grid;
  grid-template-columns: 1fr 40px;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
  border: 1px solid #00c9ff;
  height: 4.4rem;
  align-items: center;
}

.close-bttn {
  color: #00c9ff;
  cursor: pointer;
}

.pln-title {
  margin-left: 1rem;
}


.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 0rem;
}


.container-fluid {
  margin-bottom: 15px;
}

.imageLink {
  cursor: pointer;
  color: #00c9ff
}


</style>



